/**
 * @author Pawan Sadvale
 * @email Pawan.Sadvale@ul.com
 * @create date 2020-09-18 09:21:03
 * @modify date 2020-09-18 09:21:03
 * @desc api services page
 */
import axios from 'axios';

/**
 * resource dashboard get countries api
 * to get all the countries with sercies and resources */
export async function getResoucesCountries() {
  let data;
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/resource/dashboard/countries`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        data = response.data.data;
      }
    })
    .catch((err) => {
      console.log('resources dashboard countries api error', err); // eslint-disable-line no-console
    });
  return data;
}

/**
 * resource dashboard get resources list api
 * to get the list of resources */
export async function getResourcesList() {
  let data;
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/resource/dashboard/resources`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        data = response.data.data;
      }
    })
    .catch((err) => {
      console.log('resources dashboard resources list api error', err); // eslint-disable-line no-console
    });
  return data;
}

/**
 * resource dashboard getCountriesByResourceId api
 * to get the list of coutries with resource available */
export async function getCountriesByResourceId(id) {
  let data;
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/resource/dashboard/resource/${id}`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        data = response.data.data;
      }
    })
    .catch((err) => {
      console.log('resources dashboard getCountriesByResourceId api error', err); // eslint-disable-line no-console
    });
  return data;
}

/**
 * resource dashboard getCountriesByServiceId api
 * to get the list of coutries with service available */
export async function getCountriesByServiceId(id) {
  let data;
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/resource/dashboard/service/${id}`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        data = response.data.data;
      }
    })
    .catch((err) => {
      console.log('resources dashboard getCountriesByServiceId api error', err); // eslint-disable-line no-console
    });
  return data;
}

/**
 * resource dashboard getEUCountriesList api
 * to get the list of eu coutries */
export async function getEUCountriesList() {
  let data;
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/resource/dashboard/eu/countries`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        data = response.data.data;
      }
    })
    .catch((err) => {
      console.log('resources dashboard getEUCountriesList api error', err); // eslint-disable-line no-console
    });
  return data;
}
